
<template>
  <div class="bgfff">
    <iHeader />
    <iNav ref="iNav" />
    <!-- <iClassify :active="1" all-active /> -->
    <iRightFixedBox ref="iRightFixedBox" />
    <div
      v-if="loading"
      style="margin-left: calc((100vw - 1200px) / 2); width: 1200px; max-width: 1200px;"
    >
      <van-row gutter="60">
        <van-col :span="8">
          <van-skeleton
            avatar
            avatar-shape="square"
            avatar-size="300px"
            :loading="loading"
            style="margin-top: 40px;"
          />
        </van-col>
        <van-col :span="14">
          <van-skeleton
            :row="10"
            title
            :loading="loading"
            style="margin-top: 40px;"
          />
        </van-col>
      </van-row>
      <van-skeleton
        :row="13"
        title
        :loading="loading"
        style="margin-top: 40px;"
      />
    </div>
    <div v-if="!loading" style="min-height: 600px;">
      <div id="goods-details" ref="product_a">
        <div class="goods-base-div">
          <div>
            <ImageViews
              ref="ImageViews"
              :logo="product.Logo"
              :images="topImages"
            />
            <!-- 类型icon -->
            <div class="type-icon">
              <div v-if="iconType.includes(type)">
                <div :class="['icon-lt','icon-lt-'+type]">
                  <img :src="require(`@/assets/buycar/type-${type}.png`)" alt="">
                </div>
                <!-- <div v-if="type==5" :class="['icon-tj']">{{8.8}}折</div> -->
              </div>
            </div>
          </div>

          <!-- 商品信息 -->
          <div class="goods-msg-box">
            <!-- 商品头部信息 -->
            <div class="goods-title">

              <!-- 新品 -->
              <span
                v-if="
                  product.IsNewGoods
                "
                class=""
                style="margin-right: 8px;"
              >
                <img style="width: 30px;" src="@/assets/goods/new.png">
              </span>

              <span
                class="name"
              >{{
                _showProductTitle(product.SkuName, product.OperationName)
              }}/</span>
              <span class="specifications">{{ product.Specifications }}/{{ product.Unit }}</span>
            </div>

            <div v-if="product.SellingPoin" class="goods-disc">{{ product.SellingPoint }}</div>
            <div v-if="!sortList.length" style="margin: 24px 0;" />
            <!-- 商品标签 -->
            <div v-if="sortList.length" class="tag-list">
              <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
              <div v-for="(val,idx) in sortList" v-if="val.txt && val.txt!=='非医保'" :key="idx" :class="['tag-box','tag-type-'+val.type]">{{ val.txt }}</div>
            </div>
            <!-- 公共区域 -->
            <div class="msg-content content-bg1 content-bg2">
              <!-- head-bg3-新品抢购底图 -->
              <div
                v-if="
                  product.NewProductTime &&
                    moment().isBefore(moment(product.NewProductTime))
                "
                class="head head-bg3"
              />
              <!-- 预计到货   "-->
              <div
                v-if="!product.Stock || product.Stock <= 0"
                class="head"
                :class="{
                  'head-bg4': true,
                  'head-bgt': product.EstimatedTime && getMomentStatus(),
                }"
              >
                <van-count-down
                  v-if="product.EstimatedTime && getMomentStatus()"
                  :time="moment(product.EstimatedTime).diff(moment())"
                  style="display: flex;"
                  @finish="timeFinish"
                >
                  <template #default="timeData">
                    <div class="time">{{ timeData.days }}天/</div>
                    <div class="time">
                      {{
                        timeData.hours > 9
                          ? timeData.hours
                          : "0" + timeData.hours
                      }}时
                    </div>
                    <div class="time">
                      {{
                        timeData.minutes > 9
                          ? timeData.minutes
                          : "0" + timeData.minutes
                      }}分
                    </div>
                    <div class="time">
                      {{
                        timeData.seconds > 9
                          ? timeData.seconds
                          : "0" + timeData.seconds
                      }}秒
                    </div>
                  </template>
                </van-count-down>
              </div>
              <!-- 超出经营范围 -->
              <div
                v-if="product.IsOutBusinessScope"
                class="head head-bgr"
              />
            </div>
            <div
              v-if=" type!==5 "
              class="msg-content"
            >

              <!-- 特殊活动 头部区域 || 9 -->
              <div
                v-if="type && type !=9"
                :class="['head',``]"
                :style="{'backgroundImage':'url('+require(`@/assets/buycardetail/type-${type}-${defaultType}.png`)+')'}"
              >
                <!-- txtColorType.includes(type)?'#ffffff':'#111A34 ', -->
                <div
                  v-if="timerShouldDisplay"
                  :class="txtColorType.includes(type)?'white-txt text':'red-txt text'"
                  style="margin-right: 8px; margin-bottom: 2px; font-size: 14px; font-weight: bold;"
                >
                  <img
                    :src="require(!txtColorType.includes(type)?'../../assets/goods/time.png':'../../assets/buycardetail/lighting-1.png')"
                    style="margin-right: 2px; width: 14px; height: 14px;"
                  >
                  {{
                    activityCountdownInfo.countdownType === 2
                      ? "距离活动结束"
                      : "距活动开始"
                  }}仅剩
                  <span style="margin-left: 10px; color: #111A34;">
                    {{ activityCountdownInfo.Days }}天
                  </span>

                </div>
                <van-count-down
                  v-if="timerShouldDisplay"
                  :time="activityCountdownInfo.TotalMilliseconds"
                  style="display: flex;
    align-items: flex-end;
    margin-bottom: 3px;"
                >
                  <template #default="timeData">
                    <div class="timer-box">
                      {{
                        timeData.hours > 9
                          ? timeData.hours
                          : "0" + timeData.hours
                      }}
                    </div>
                    <div class="time-f">:</div>
                    <div class="timer-box">
                      {{
                        timeData.minutes > 9
                          ? timeData.minutes
                          : "0" + timeData.minutes
                      }}
                    </div>
                    <div class="time-f">:</div>
                    <div class="timer-box">
                      {{
                        timeData.seconds > 9
                          ? timeData.seconds
                          : "0" + timeData.seconds
                      }}
                    </div>
                  </template>
                </van-count-down>
                <div class="more-cut" @click="goMoreCutPage()">
                  <span>更多优惠 <img
                    src="../../assets/buycardetail/w-right.png"
                  ></span>
                </div>
              </div>

              <!-- 普通商品基本信息 -->
              <div
                class="content-center"
                :class="{
                  'content-bg1': !type,
                  'content-bg2': type
                }"
              >
                <div class="item-cell">
                  <!-- <div class="lable-name">供货价</div> -->
                  <div class="right">
                    <!-- 非特殊 -->
                    <div v-if="type != 8 && type!=9" class="flex a-c m-b8">
                      <!-- 活动商品原价 -->
                      <div v-if="!ActivityDataDto.ActivityPrice" style="font-size: 20px; font-weight: bold;" class="price">
                        ¥ <span style="font-size: 28px;">{{ _moneyFormat(product.PriceLimit) }}</span>
                      </div>

                      <!-- 优惠价 -->
                      <div v-else class="a-price">
                        <span style="margin-top: 4px; font-size: 20px; color: #FF3939;">¥</span>

                        <span
                          v-if=" Countdown !== null && Countdown.countdownType === 1 "
                          class="num"
                        >
                          {{
                            _moneyFormat(ActivityDataDto.ActivityPrice)
                              .toString()
                              .replace(/[0-9]/gi, "?")
                          }}
                        </span>
                        <span
                          v-else
                          class="num"
                        >{{ _moneyFormat(ActivityDataDto.ActivityPrice) }}</span>
                      </div>
                      <span
                        v-if=" product.SourceGoodsSkuId && product.IsShowOriginalPrice"
                        style="margin-right: 8px; font-size: 14px; font-weight: bold; text-decoration: line-through; color: #858B9C;"
                      >
                        ¥ {{ _moneyFormat(product.PriceLimit) }}
                      </span>
                      <!-- 折后约 -->
                      <span v-if="type==6 && ActivityDataDto.Price" class="zhy" @click="showZhy()"> <span style="margin-right: 4px;">折后约</span> <span class="fAvenirH">¥{{ ActivityDataDto.Price }}</span> <span> <img class="info" src="@/assets/buycardetail/info.png" alt=""></span> </span>
                      <!-- 毛利 -->
                      <div
                        v-if="product.RetailPrice && product.RetailPrice != 0"
                        class="ll"
                        :class="{
                          'll-bg1': !type,
                          'll-bg2': type
                        }"
                      >
                        {{ lang.Goods.Profit }}
                        {{
                          _showProductProfit(
                            product.RetailPrice,
                            _getProductPrice(
                              ActivityDataDto.ActivityPrice,
                              product.PriceLimit
                            )
                          ) + "%"
                        }}
                      </div>
                    </div>
                    <!-- 秒杀 -->
                    <div v-else class="flex a-c m-b8  " style="justify-content: space-between;">
                      <div class="flex a-c m-b8">
                        <!-- 优惠价 -->
                        <div v-if="ActivityDataDto.ActivityPrice" class="a-price" style="color: #FF3939;">
                          <img src="@/assets/buycardetail/low-price.png" style="width: 28px; height: 16px;" alt="">
                          <span style="margin-top: 4px; margin-left: 4px; font-size: 20px; font-weight: bold; color: #FF3939;">¥</span>
                          <span
                            v-if="Countdown !== null && Countdown.countdownType === 1"
                            class="num"
                          >

                            {{
                              _moneyFormat(ActivityDataDto.ActivityPrice)
                                .toString()
                                .replace(/[0-9]/gi, "?")
                            }}
                          </span>
                          <span
                            v-else
                            class="num"
                          > {{ _moneyFormat(ActivityDataDto.ActivityPrice) }}</span>
                        </div>
                        <!-- 活动商品原价 -->
                        <div class="price" style="font-size: 18px; font-family: auto; color: #858B9C;">
                          <s>¥ {{ _moneyFormat(product.Price) }}</s>
                        </div>
                        <span
                          v-if="
                            product.SourceGoodsSkuId &&
                              product.IsShowOriginalPrice
                          "
                          style="margin-right: 8px; font-size: 14px; font-weight: bold; text-decoration: line-through; color: #858B9C;"
                        >
                          ¥ {{ _moneyFormat(product.PriceLimit) }}
                        </span>

                        <!-- 毛利 -->
                        <div
                          v-if="product.RetailPrice && product.RetailPrice != 0"
                          class="ll ll-bg2"
                        >
                          {{ lang.Goods.Profit }}
                          {{
                            _showProductProfit(
                              product.RetailPrice,
                              _getProductPrice(
                                ActivityDataDto.ActivityPrice,
                                product.PriceLimit
                              )
                            ) + "%"
                          }}
                        </div>
                      </div>
                      <!-- 秒杀的进度条 -->
                      <div v-if="SoldOutMsDto" class="process">
                        <el-progress style="width: 138px;" :text-inside="true" :stroke-width="16" :percentage="SoldOutMsDto.radio" />
                        <span style="margin-left: 4px; color: #F22F15;">已售<span>{{ SoldOutMsDto.soldOutNumber }}</span> </span>
                      </div>
                      <!-- 效期的倒计时 -->
                      <div v-if="timerShouldDisplay && type==9" class="main-type-9">
                        <div

                          class="white-txt red-txt text "
                          style="margin-right: 8px; font-size: 14px; font-weight: bold;"
                        >
                          <img
                            :src="require(!txtColorType.includes(type)?'../../assets/goods/time.png':'../../assets/buycardetail/lighting-1.png')"
                            style="margin-right: 4px; width: 14px; height: 14px;"
                          >
                          {{
                            activityCountdownInfo.countdownType === 2
                              ? "距离活动结束"
                              : "距活动开始"
                          }}仅剩
                          <span style="margin-left: 10px; color: #111A34;">{{ activityCountdownInfo.Days }}天</span>

                        </div>
                        <van-count-down
                          v-if="timerShouldDisplay"
                          :time="activityCountdownInfo.TotalMilliseconds"
                          style="display: flex;"
                          class=""
                        >
                          <template #default="timeData">
                            <div class="timer-box">
                              {{
                                timeData.hours > 9
                                  ? timeData.hours
                                  : "0" + timeData.hours
                              }}
                            </div>
                            <div class="time-f">:</div>
                            <div class="timer-box">
                              {{
                                timeData.minutes > 9
                                  ? timeData.minutes
                                  : "0" + timeData.minutes
                              }}
                            </div>
                            <div class="time-f">:</div>
                            <div class="timer-box">
                              {{
                                timeData.seconds > 9
                                  ? timeData.seconds
                                  : "0" + timeData.seconds
                              }}
                            </div>
                          </template>
                        </van-count-down>
                        <div class="more-cut" @click="goMoreCutPage()">
                          <span>更多优惠
                            <img
                              src="../../assets/buycardetail/w-right.png"
                            >
                          </span>
                        </div>
                      </div>

                    </div>
                    <div class="flex sub-p">
                      <img
                        src="../../assets/goods/sale.png"
                        style="margin: 1px 4px 0 0; width: 14px; height: 14px;"
                        alt=""
                        srcset=""
                      >
                      <span
                        class="m-r24"
                      >最低零售价 {{ lang.Basic.Price
                      }}{{ _moneyFormat(product.RetailPrice) }}</span>
                      <img
                        style="margin: 2px 4px 0 0; width: 14px; height: 14px;"
                        src="../../assets/goods/up.png"
                        alt=""
                        srcset=""
                      >
                      <span>
                        赚 {{ lang.Basic.Price }}{{
                          (
                            product.RetailPrice -
                            _getProductPrice(
                              product.PriceActivity,
                              product.PriceLimit
                            )
                          ).toFixed(2)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 控销 -->
              <div
                v-if=" product.ActivityPresentList.length === 0 && !product.SourceGoodsSkuId &&product.MarketControlInfo"
                class="head"
                :class="{
                  'head-bg5': true,
                }"
              >
                <div
                  v-if="!product.MarketControlInfo.IsOverControlTime"
                  class="text"
                >
                  <div
                    v-if="product.MarketControlInfo.WillFreeControlDays > 15"
                  >
                    <span>距控销释放还剩：{{
                      product.MarketControlInfo.WillFreeControlDays
                    }}天</span>
                  </div>
                  <div v-else>
                    <span>距控销释放还剩：</span>
                    {{ product.MarketControlInfo.WillFreeControlDays }}天
                  </div>
                </div>
                <div v-else class="text">
                  <span>已过释放期，</span>{{
                    product.MarketControlInfo.WillLoseControlDays
                  }}天后将失去控销权
                </div>
              </div>
            </div>

            <!-- 特价单独展示信息 -->

            <div v-if="type ==5" class="main-content">
              <div class="count-time">
                <div class="left">
                  <span><img src="@/assets/buycardetail/zk-1.png" alt=""></span>
                  <span v-if="ActivityDataDto.ActivityPrice" class="price" style="font-size: 20px;">
                    ¥<span>{{ _moneyFormat(ActivityDataDto.ActivityPrice) }}</span>
                  </span>
                  <span v-if="ActivityDataDto.ActivityDiscount" class="cut">享 <span class=" fAvenirH">{{ ActivityDataDto.ActivityDiscount }} </span>折</span>
                  <s style="margin-left: 4px;">原价 ¥<span>{{ _moneyFormat(product.Price) }}</span></s>
                </div>
                <div v-if="timerShouldDisplay" class="right">
                  <span> <img src="@/assets/buycardetail/lighting-1.png" alt=""> </span>
                  <span style="margin-right: 12px; color: #FFFFFF;">
                    {{ activityCountdownInfo.countdownType === 2 ? "距活动结束" : "距活动开始" }}仅剩
                  </span>
                  <span>{{ activityCountdownInfo.Days }} 天 </span>
                  <span class="timer">
                    <van-count-down
                      :time="activityCountdownInfo.TotalMilliseconds"
                      style="display: flex;"
                    >
                      <template #default="timeData">
                        <div class="timer-box">
                          {{
                            timeData.hours > 9
                              ? timeData.hours
                              : "0" + timeData.hours
                          }}
                        </div>
                        <div class="time-f">:</div>
                        <div class="timer-box">
                          {{
                            timeData.minutes > 9
                              ? timeData.minutes
                              : "0" + timeData.minutes
                          }}
                        </div>
                        <div class="time-f">:</div>
                        <div class="timer-box">
                          {{
                            timeData.seconds > 9
                              ? timeData.seconds
                              : "0" + timeData.seconds
                          }}
                        </div>
                      </template>
                    </van-count-down>
                  </span>
                </div>
              </div>
              <div class="price-info">
                <div class="left">
                  <div>
                    <span> <img src="@/assets/buycardetail/bfh.png" alt=""> </span>
                    <span v-if="product.RetailPrice && product.RetailPrice != 0"> 毛利率
                      {{ product.RetailPrice==0?0:
                        _showProductProfit(
                          product.RetailPrice,
                          _getProductPrice(
                            ActivityDataDto.ActivityPrice,
                            product.PriceLimit
                          )
                        ) + "%"
                      }}</span>
                    <span style="margin-left: 38px;"> <img src="@/assets/buycardetail/sell.png" alt=""> </span>
                    <span>最低零售价 ¥ {{ _moneyFormat(product.RetailPrice) }}</span>
                    <span> <img src="@/assets/buycardetail/up.png" alt=""> </span>
                    <span>赚 ¥{{
                      (
                        product.RetailPrice -
                        _getProductPrice(
                          ActivityDataDto.ActivityPrice,
                          product.PriceLimit
                        )
                      ).toFixed(2)
                    }}</span>
                  </div>
                </div>
                <div class="right">
                  <div class="more-cut" @click="goMoreCutPage()">
                    <span>更多优惠 <img
                      src="../../assets/buycardetail/w-right.png"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 领取优惠券信息 活动基本信息 -->
            <div class="msg-content active-center">
              <div
                v-if="ReceivePanelCoupons.length "
                class="content-center "
              >
                <div class="item-cell">
                  <!-- <div class="lable-name">优惠</div> -->
                  <div class="right">
                    <!-- 优惠券 -->
                    <div
                      v-if="ReceivePanelCoupons.length && !isActivityGoods"
                      class="flex a-c f-w m-b8"
                    >
                      <div class="icon-coupon m-r8 p-r">
                        <ProductDetailsCoupon
                          ref="coupon"
                          :coupon-list="ReceivePanelCoupons"
                          @handleDraw="handleDraw"
                        />
                      </div>
                      <div
                        v-for="(item, index) in ReceivePanelCoupons"
                        :key="index"
                        class="coupon-item"
                        @click.stop="handleShowCoupon"
                      >
                        <div class="item left">{{ item.Name }}</div>
                        <img
                          src="@/assets/coupon-c.png"
                          class="coupon-c"
                          alt=""
                        >
                        <div class="item right">领取</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 赠送信息列表 -->
            <div v-if="ActivityDataDto && ActivityDataDto.ActivityConfigs && ActivityDataDto.ActivityConfigs.length" class="mj-yh-box">
              <div class="left-mj">
                <div class="out-txt"> <div class="dot"> {{ !txtColorType.includes(type)?'':defaultType==1?'单品':'组合' }}{{ getConfigType(type) }}</div></div>
                <div class="coupon-list">

                  <div v-for="(v,i) in ActivityDataDto.ActivityConfigs" :key="i">
                    <span style="margin-right: 8px;"> {{ eachTypeList.includes(ActivityDataDto.ActivityTypeCode)?'每':'' }}满{{ v.OrderAmount }}{{ doubleList.includes(type)?(defaultType==2?'元':'盒'):'元' }} </span>
                    <span v-if="!v.ActivityConfigPresents.length">，{{ v.DiscountType==1?'减免':'打' }} {{ v.Discount }} {{ v.DiscountType==1?'元':'折' }} </span>

                    <span v-else class="long-txt">
                      <!-- 优惠券 -->
                      <template v-if="type==7">返
                        <span v-for="(vv,ii) in v.ActivityConfigPresents" :key="ii">
                          {{ vv.Name }}*{{ vv.Stock }}张{{ ii+1!=v.ActivityConfigPresents.length?',':'' }}
                        </span>
                      </template>
                      <template v-if="type==3">赠
                        <span v-for="(vv,ii) in v.ActivityConfigPresents" :key="ii">
                          【{{ vv.Name }}】* {{ vv.Stock }} {{ ii+1!=v.ActivityConfigPresents.length?'+':'' }}
                        </span>
                      </template>
                      <template v-if="type==4">
                        <span v-for="(vv,ii) in v.ActivityConfigPresents" :key="ii">
                          {{ ii!=v.ActivityConfigPresents.length?'+':'' }} {{ _moneyFormat(vv.Amount* vv.Stock) }}元换购【{{ vv.Name }} 】*{{ vv.Stock }}
                        </span>
                      </template>

                    </span>
                  </div>

                </div>
              </div>

              <div class="check" @click="goCheck()"><div>去看看 ></div></div>
            </div>
            <!-- 价格活动相关信息 -->

            <!-- 产品其他属性 -->
            <div class="goods-attributes-div flex-row">
              <!-- <div
                v-if="product.Specifications"
                class="attribute-group flex-row"
              >
                <div class="title">药品规格</div>
                <div class="value van-ellipsis">
                  {{ product.Specifications }}/{{ product.Unit }}
                </div>
              </div> -->
              <div
                v-for="properties in baseAttribute"
                :key="properties.AttributeId"
                class="attribute-group flex-row"
              >
                <div class="title">{{ properties.AttributeName }}</div>
                <div
                  class="value van-ellipsis"
                >
                  {{
                    properties.AttributeValue =='/'?'': properties.AttributeValue
                  }}
                  <span
                    v-if="showCopy.includes(properties.AttributeName) && properties.AttributeValue !='/' && properties.AttributeValue"
                    v-clipboard:copy="properties.AttributeValue"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    style="display: inline-block; color: #1989FA;"
                    class=" ml20 fzBtn"
                  >复制</span>
                </div>
              </div>
            </div>
            <!-- /产品属性 -->
            <div
              v-if="
                product.IsPutaway
              "
              class="goods-cartNum-div flex-row"
            >
              <div class="title" style="color: #111A34;">购买数量</div>
              <div class="stepper">
                <van-stepper
                  v-model="product.cartNum"
                  :min="addCartSetting.StartBuyNumb"
                  :step="addCartSetting.StepSize"
                  :disable-plus="(ActivityDataDto.SigleOrderLimitNumb && product.cartNum+addCartSetting.StepSize >= ActivityDataDto.SigleOrderLimitNumb) || product.cartNum >= product.Stock"
                  integer
                />
              </div>
              <div class="goods-sotck">
                <span v-if="product.Stock >= 100">{{ lang.Goods.Sotck }}</span>
                <span
                  v-else-if="product.Stock < 100 && product.Stock >= 0"
                  class="red"
                >库存数量：{{ product.Stock }}</span>
              </div>
            </div>
            <!-- 加购按钮 -->
            <div class="goods-addCart-div flex-row">
              <div
                v-if="
                  activityCountdownInfo.countdownType === 1 ||
                    (activeIsBegin && !product.IsAdd)
                "
                style="display: flex;"
              >
                <div class="ready-btn" style="flex: 0 0 154px;">即将开始</div>
                <div
                  style="flex: 0 0 80px;"
                  :class="
                    `${
                      collects.Goods.IsCollect
                        ? 'goods-a-favorites'
                        : 'goods-favorites'
                    }`
                  "
                  @click.stop="operateCollect(Enum_CollectType.Goods)"
                >
                  <div />
                </div>
              </div>

              <div v-else-if="product.IsPutaway" class="flex-row">
                <div
                  v-if="
                    cusOtherInfo.IsShowPrice ||
                      getProductLabType(product).length
                  "
                  :class="
                    `${
                      product.Stock <= 0
                        ? collects.Subscribe.IsCollect
                          ? 'goods-gray'
                          : 'goods-red'
                        : product.IsOutBusinessScope
                          ? 'goods-out'
                          : 'goods-addCart'
                    }`
                  "
                >
                  <div
                    v-if="product.IsOutBusinessScope"
                    class="pd015"
                    style="background: #0F6EEA;"
                    @click.stop="goConsummate(product.BusinessScope)"
                  >
                    {{ "超出经营范围 , 去完善" }}
                  </div>
                  <div
                    v-else-if="product.Stock <= 0"
                    class="pd015 colect_btn"
                    @click.stop="operateCollect(Enum_CollectType.Subscribe)"
                  >
                    {{ collects.Subscribe.IsCollect ? "已订阅" : "到货通知" }}
                  </div>
                  <div
                    v-else
                    style="text-align: center;"
                    @click.stop="confirmCart"
                  >
                    {{
                      product.ActivityPresentList.length === 0 &&
                        !product.SourceGoodsSkuId &&
                        product.MarketControlInfo &&
                        product.MarketControlInfo.IsOverControlTime
                        ? "优先控销"
                        : product.ActivityPresentList.length === 0 &&
                          !product.SourceGoodsSkuId &&
                          product.MarketControlInfo &&
                          !product.MarketControlInfo.IsOverControlTime
                          ? "控销"
                          : "加入购物车"
                    }}
                  </div>
                </div>
                <div v-else class="goods-gray pd015"><span>无法购买</span></div>
                <div
                  :class="
                    `${
                      collects.Goods.IsCollect
                        ? 'goods-a-favorites'
                        : 'goods-favorites'
                    }`
                  "
                  @click.stop="operateCollect(Enum_CollectType.Goods)"
                >
                  <div />
                </div>
              </div>
              <div v-else class="goods-gray"><span>已下架</span></div>
              <Live-Room
                v-if="IsLiveRoom || IsReview"
                ref="LiveRoom"
                :is-review="IsReview"
                :live-room-url="LiveRoomUrl"
              />
            </div>
          </div>
        </div>
        <!-- 商品详情 -->
        <div class="goods-base-div flex-row">
          <!-- 推荐商品 -->
          <div class="goods-relevant-div">
            <div class="title">相关推荐</div>
            <div class="listbox">
              <product-list-item
                v-for="goods in relevantList"
                v-if="relevantList && relevantList.length"
                :key="goods.Id"
                :ref="'p_' + goods.Id"
                :product="_itemToGoods(goods)"
                goods-type="RecommendGoods"
                @showProduct="
                  () => {
                    showRouter(goods);
                  }
                "
              />
            </div>
          </div>
          <!-- /推荐商品 -->
          <div class="goods-details-div">
            <div class="goods-details-box">
              <div class="title">使用说明</div>
              <div class="content flex-row">
                <div
                  v-for="(attributes, i) in extendAttribute"
                  v-if="attributes.AttributeValue"
                  :key="attributes.AttributeId"
                  class="flex-row"
                >
                  <div class="title">{{ attributes.AttributeName }}</div>
                  <div :class="`${i < 4 ? 'value-double' : 'value'}`">
                    {{ attributes.AttributeValue }}
                  </div>
                </div>
              </div>
            </div>
            <div class="goods-details-box" style="margin-top: 20px;">
              <div class="title">图文详情</div>
              <div class="content-html" style="margin-top: 0;">
                <div v-for="item in detailsImages" :key="item.Id">
                  <van-image lazy-load :src="_getPic(item.ResourcesUrl)" />
                </div>
                <div class="mainbody-html">
                  <div v-html="product.MainBody" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 对话框 -->
        <iDialog
          ref="iDialogref"
          :show-cancel-btn="false"
          confirm-btn-text="确定"
          width="607px"
          close
        >
          <template #bottom>
            <div class="pb10">
              <van-icon
                size="90px"
                :name="require('@/assets/mine/fankui-success-icon.png')"
                class="mt108"
              />
              <div class="f26 c0F6EEA fw600 mb10 mt30">领取成功</div>
              <div class="c777 f14 mb5">可以前往我的优惠券查看详情！</div>
            </div>
          </template>
        </iDialog>
      </div>
    </div>

    <!-- 完善资料提示 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>你需要提交包含,{{ dialogVisibleText }},才可以购买商品</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="go(dialogVisibleType)"
        >确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import { BaseMixin } from '@/mixins/BaseMixin'
import { NavbarShowType } from '@/dictionary/navbar.js'
import {
  RotationPlotShowType,
  LabelType,
  ReducationType,
  PackageGiftType,
  CollectType
} from '@/dictionary/goods.js'
import { Base, Extend } from '@/config/goods.js'
import ProductListItem from '@/components/ProductListItem'
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iRightFixedBox from '@/components/RightFixedBox'
import CouponLabel from '@/components/CouponLabel'
import ImageViews from '@/components/ImageViews'
import iCoupon from '@/components/iCoupon'
import iDialog from '@/components/iDialog'
import ProductDetailsCoupon from './ProductDetailsCoupon.vue'
import { LinkTypeCode } from '@/dictionary/base'
import LiveRoom from '@/components/LiveRoom'
export default {
  name: 'ProductDetails',
  components: {
    iHeader,
    iNav,
    iClassify,
    CouponLabel,
    iRightFixedBox,
    ImageViews,
    ProductListItem,
    iCoupon,
    iDialog,
    ProductDetailsCoupon,
    LiveRoom
  },
  mixins: [BaseMixin],
  props: {
    // 详情中的是否可以加购
    isShowAdd: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      //  { type: 1, txt: '换购' },
      //   { type: 2, txt: '乙类' },
      //   { type: 3, txt: '国家码' }
      goodsTagList: [], // 商品标签
      typeList: [
        { val: '', label: '全部' },
        { val: 5, label: '特价' },
        { val: 6, label: '满减' },
        { val: 3, label: '满赠' },
        { val: 7, label: '满返' },
        { val: 4, label: '换购' },
        { val: 8, label: '秒杀' },
        { val: 9, label: '效期' }
      ],
      eachTypeList: [8, 32, 512], // 每满
      doubleList: [3, 4],
      type: null,
      showCopy: ['批准文号', '条形编码', '医保代码'],
      defaultType: 1,
      // 特殊位置得标签 活动类型标记 右上角位置展示icon
      iconType: [9, 8, 5],
      // 下方字体颜色
      txtColorType: [4, 3],
      addCartSetting: {
        SigleOrderLimitNumb: 0,
        StartBuyNumb: 0,
        StepSize: 0
      },

      activeIsBegin: false, // 活动是否开始
      IsOpenPreActivity: false, // 活动是否开始预热
      RuleText: '', // 无权购买时参与条件
      ConditionRelation: '', // 多条件规则关系
      dialogVisible: false,
      dialogVisibleText: '',
      dialogVisibleType: null,
      // 展示活动还是优惠
      ConditionType: null,
      loading: true,
      showCouponPanel: false,
      // 商品活动信息
      ConfigType: null,
      GoodsActivities: [],
      activityCountdownInfo: {},
      finished: false,
      paddingBottom: 0,
      medicineTypeNoList: ['非医保', '甲类', '乙类', '医保'],
      showAttributePanel: ['1'],
      Enum_RotationPlotShowType: RotationPlotShowType,
      Enum_LabelType: LabelType,
      Enum_NavbarShowType: NavbarShowType,
      Enum_ReducationType: ReducationType,
      Enum_PackageGiftType: PackageGiftType,
      Enum_CollectType: CollectType,
      Config_Base: Base,
      Config_Extend: Extend,
      collects: {
        Goods: { Id: '', IsCollect: false },
        Subscribe: { Id: '', IsCollect: false }
      },
      cartCount: 0,
      timer: {
        new: {},
        newTime: {},
        soon: {},
        soonTime: {}
      },
      activityInterval: null, // 活动倒计时定时器
      activityTimer: {}, // 活动倒计时对象
      coupons: {
        ReceiveCoupons: [],
        GiftCoupons: []
      },
      ReceivePanelCoupons: [],
      salesPromotions: {
        MoneyPresents: [],
        AmountPresents: [],
        Reductions: [],
        SingleProducts: []
      },
      secondAttribute: [],
      extendAttribute: [],
      baseAttribute: [],
      videos: [],
      topImages: [],
      detailsImages: [],
      relevantList: [],
      isActivityGoods: '',
      product: {},
      url: {
        getGoodsSkuDetail: '/api_goods/GoodsSku/GetGoodsSkuDetailV2', // 获取商品信息

        createLike: '/api_customer/CustomerCollect/Create', // 客户收藏&订阅到货通知
        deleteLike: '/api_customer/CustomerCollect/PhysicalDeleteBatch', // 客户取消收藏&到货通知
        getCollect: '/api_customer/CustomerCollect/IsCollect', // 是否收藏&订阅
        getCoupons: '/api_coupon/Coupon/GetCoupons', // 领券中心
        getPlayAuth: '/api_basedata/Aliplay/GetPlayauth', // 获取视频播放凭证
        getRandomGoods: '/api_goods/GoodsSku/RandomGetGoodsList', // 随机获取商品
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart'
      },
      cusOtherInfo: {
        IsShowPrice: false,
        IsOrder: false,
        NoPriceTitle: '暂无价格'
      },
      Countdown: {},
      joinModal: false,
      // 不满足参加条件的提示弹窗显示
      conditionModal: false,
      isOldBuy: false,
      IsLiveRoom: false,
      LiveRoomUrl: '',
      IsReview: '',
      ActivityDataDto: null,
      ActivityId: '', // 活动专区ID
      SoldOutMsDto: null
    }
  },
  computed: {
    timerShouldDisplay() {
      return this.activityCountdownInfo && Object.keys(this.activityCountdownInfo).length &&
                      (this.activityCountdownInfo.countdownType === 2 ||
                        this.activityCountdownInfo.countdownType === 1) &&
                      !this.getMomentStatus()
    },
    sortList() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.goodsTagList.sort((a, b) => a.type - b.type).filter(val => val.txt)
    }
  },
  watch: {
    isOldBuy: {
      handler(val) {
        if (val) {
          this.confirmCart()
        }
      }
    }
  },
  created() {
    // 专区活动商品的configType
    const {
      configType = '',
      ruleText = '',
      conditionRelation,
      IsOpenPreActivity,
      activeIsBegin
    } = this.$route.query
    if (IsOpenPreActivity || activeIsBegin) {
      this.IsOpenPreActivity = IsOpenPreActivity !== 'false'
      this.activeIsBegin = activeIsBegin !== 'false'
    }
    this.RuleText = ruleText
    this.ConditionRelation = conditionRelation
    this.ConfigType = configType

    this.getGoodsActivity()
    // 推荐商品
    this.getRandomGoods()
    // 直播信息
    this.getLiveRoomMsg()
  },
  mounted() {
    this.isActivityGoods = this.$route.query.detailType
    const info = this.$auth.getCustomerOtherInfo()
    if (info) {
      this.cusOtherInfo = info
    }
  },
  beforeDestroy() {
    if (this.timer.new) {
      clearInterval(this.timer.new)
      this.timer.newTime = {}
    }
    if (this.timer.soon) {
      clearInterval(this.timer.soon)
      this.timer.soonTime = {}
    }
    if (this.activityInterval) {
      clearInterval(this.activityInterval)
    }
  },
  methods: {
    moment,
    // 转化对应类型
    getConfigType(data) {
      const dataArr = this.typeList.filter(v => v.val == data)
      return dataArr.length ? dataArr[0].label : '-'
    },
    // 去看看
    goCheck() {
      this.goMoreCutPage()
    },
    // 获取直播信息
    async getLiveRoomMsg() {
      const res = await this.getAction('/api_goods/GoodsLive/GetLiveRoomMsg', {
        goodsId: this.$route.query.goodsId
      })
      if (res.IsSuccess) {
        this.IsReview = res.Data.IsReview
        this.IsLiveRoom = res.Data.IsLive
        this.LiveRoomUrl = res.Data.LiveRoomUrl
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    getMomentStatus() {
      const { EstimatedTime } = this.product
      return moment().isBefore(moment(EstimatedTime))
    },
    // 采用原价购买
    timeFinish() {
      window.onload()
    },
    oldBuy() {
      // 改变状态转入商品组件，以便采用原始ID购买
      this.isOldBuy = true
      // 关闭弹窗
      this.joinModal = false
      // 改变为可以购买
      // this.isShowAdd = true
    },
    // 查看参与条件
    lookCond() {
      this.joinModal = false
      this.conditionModal = true
    },
    // 跳转活动专区商品列表
    toActiveList(Id, str) {
      this._jump(
        this.Enum_LinkTypeCode.ActivityProductList,
        {
          id: Id,
          str
        },
        '_blank'
      )
    },
    // 遍历活动信息
    changeString(children, item) {
      let str = ''
      str =
        item.ConditionType == 1
          ? '满'
          : item.ConditionType == 2
            ? '每满'
            : item.ConditionType == 3
              ? '买'
              : '每买'
      str = str + (children.Condition && children.Condition.toString())
      str = str + (children.ConditionValueType == 1 ? '元' : '盒')
      if (children.DiscountType) {
        str = str + (children.DiscountType == 1 ? '减' : '总价打')
      }
      if (children.Discount) {
        str = str + (children.Discount ? children.Discount.toString() : '')
      }
      if (children.DiscountType) {
        str = str + (children.DiscountType == 2 ? '折' : '')
      }
      str = str + this.getGiftContent(children.Presents)
      return str
    },
    showZhy() {
      this.$toast({ message: '价格为估算价，实际优惠价格请以订单结算页为准！ ' })
    },
    /**
     * 根据赠品返回对应赠品信息文字
     */
    getGiftContent(giftArr) {
      if (!giftArr.length) {
        return ''
      }
      let giftShowContent = '赠送'
      giftArr.forEach((item, index) => {
        giftShowContent += `${item.Amount}${
          item.Type === 1 || item.Type === 2 ? '盒' : '张'
        }${item.Name ?? ''}${!item.IsMustSend ? '（选送）' : ''}${
          index < giftArr.length - 1 ? '、' : ''
        }`
      })
      return giftShowContent
    },

    // 查看更多
    goMoreCutPage() {
      if (this.type == 8) {
        this.$router.push({
          name: LinkTypeCode.ActivitySeckillView,
          query: { id: this.ActivityId }
        })
      } else if (this.type == 3 || this.type == 4) {
        this.$router.push({
          name: LinkTypeCode.ActivityGiftView,
          params: { }
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.ActivityView
        })
      }
    },
    // 获取商品活动信息
    async getGoodsActivity() {
      const res = await this.getAction(
        '/api_goods/GoodsSku/GetNewGoodsActivity?goodsSkuId=' +
          this.$route.query.goodsId
      )

      // ActivityTypeCode

      if (res.IsSuccess) {
        // 活动信息
        this.defaultType = !res.Data.ActivityMode ? 1 : res.Data.ActivityMode == 1 ? 2 : 1
        this.type = res.Data.Type
        res.Data.Type ? this.goodsTagList.push({
          type: 1,
          txt: this.getConfigType(res.Data.Type)
        }) : null
        this.activityCountdownInfo = res.Data.Countdown || {}
        this.ActivityDataDto = res.Data
        // 购买数量设置
        this.addCartSetting = {
          SigleOrderLimitNumb: res.Data.SigleOrderLimitNumb,
          StartBuyNumb: res.Data.StartBuyNumb,
          StepSize: res.Data.StepSize
        }
        this.ActivityId = res.Data.ActivityId
        // //
        this.getProduct()

        // 保存价格显示状态
        this.Countdown = res.Data.Countdown
      } else {
        this.$toast({
          message: '商品信息异常',
          icon: require('@/assets/goods/sad.png'),
          className: 'goods-toast'
        })
      }
    },
    // 完善商品首营
    async goConsummate(param) {
      const that = this
      let type = ''
      const res = await this.getAction(
        '/api_goods/GoodsSku/GetCertificateByBusinessCope',
        { businessCode: param }
      )
      if (res.IsSuccess) {
        type = res.Data
        let message = ''
        switch (type) {
          case 1:
            message = '药品经营许可证'
            break
          case 2:
            message = '第二类医疗器械经营备案凭证'
            break
          case 3:
            message = '医疗器械经营许可证'
            break
          default:
            message = '食品经营许可证'
        }
        this.dialogVisibleText = message
        this.dialogVisible = true
        this.dialogVisibleType = type
      } else {
        this.$router.push({
          name: LinkTypeCode.MyQualifications,
          params: { type: '' }
        })
      }
    },
    go(type) {
      this.$router.push({
        name: LinkTypeCode.MyQualifications,
        params: { type: type }
      })
    },
    // 获取商品
    async getProduct(goodsId) {
      const tempList = this.goodsTagList.filter((val) => val.type == 1)
      this.goodsTagList = []
      this.$hys.openLoading()
      const { getGoodsSkuDetail } = this.url
      const id = goodsId || this.$route.query.goodsId
      // const { AreaId } = this.$auth.getCustomerInfo()
      // 专区商品使用获取专区商品详情的接口
      const sendUrl = getGoodsSkuDetail
      const res = await this.getAction(`${sendUrl}?id=${id}`)
      this.$hys.clearLoading()

      if (res.IsSuccess) {
        if (this.ActivityDataDto.Type) {
          res.Data.Stock = this.ActivityDataDto.ActivityLimitNumb !== null ? (this.ActivityDataDto.ActivityLimitNumb > res.Data.Stock ? res.Data.Stock : this.ActivityDataDto.ActivityLimitNumb) : res.Data.Stock
        }
        this.product = res.Data
        this.loading = false
        if (res.Data.CountryCode) {
          tempList.push({
            type: 3,
            txt: '国家码'
          })
        }

        if (res.Data.MedicalTag) {
          tempList.push({
            type: 2, txt: this.medicineTypeNoList[Number(res.Data.MedicalTag.Value)]
          })
        }
        // 秒杀计算放大数量
        if (this.type == 8) {
          this.SoldOutMsDto = {
            soldOutNumber: this.ActivityDataDto.SellNumb,
            total: res.Data.Stock,
            radio: this.ActivityDataDto.SellPercentage
          }
        }
        this.getCollect(this.product.Id)
        if (this.product.IsOutBusinessScope) {
          this.$toast({
            message: '该商品已超出您的经营范围\n无法购买',
            icon: require('@/assets/goods/sad.png'),
            className: 'goods-toast'
          })
        }
        // 判断当前为控销商品，且当前用户不可购买时
        if (this.product.IsNotBuyOfControl) {
          this.$toast({
            message: '该商品暂不可购买',
            icon: require('@/assets/goods/sad.png'),
            className: 'goods-toast',
            overlay: true,
            onClose: () => window.close()
          })
        }
        this.goodsTagList = tempList
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
        setTimeout(() => {
          this.$router.push('/')
        }, 1500)
        return
      }
      // 同步步长设置
      if (res.Data.OutPurchaseAgreementDto) {
        this.addCartSetting = {
          SigleOrderLimitNumb: this.addCartSetting.SigleOrderLimitNumb || res.Data.OutPurchaseAgreementDto.MaxNumber || 9999999999999999999,
          StartBuyNumb: this.addCartSetting.StartBuyNumb || res.Data.OutPurchaseAgreementDto.PurchaseNumber || 1,
          StepSize: this.addCartSetting.StepSize || res.Data.OutPurchaseAgreementDto.StepLengthNumber || 1
        }
      }

      // 顶部与详情轮播图/视频 -普通商品
      if (this.product.OutRotationPlotDtos) {
        const tempTopImages = this.product.OutRotationPlotDtos.filter(
          (item) =>
            (item.Type ? item.Type : 1) == this.Enum_RotationPlotShowType.Top
        )

        // 图片排序 SortNo=1为主图
        let mainImage = null
        this.topImages = []
        tempTopImages.forEach((img) => {
          if (img.SortNo == 1) {
            mainImage = img
          }
        })
        if (mainImage) {
          this.topImages.push(mainImage)
        }
        tempTopImages.forEach((img) => {
          if (img.SortNo != 1) {
            this.topImages.push(img)
          }
        })

        // console.log(this.topImages)

        // 转换json 给imageviews组件用
        this.topImages.forEach((img, i) => {
          img.index = i
          img.url = img.ResourcesUrl
          img.thumbnails = img.ThumbnailsUrl
          img.isVideo = img.IsVideo
        })

        // 当前可以显示的图片
        if (this.topImages.length > 0) {
          this.$nextTick(() => {
            console.log(this.$refs['ImageViews'])
            this.$refs['ImageViews'].init()
          })
        }

        this.videos = this.product.OutRotationPlotDtos.filter(
          (item) =>
            item.Type == this.Enum_RotationPlotShowType.Details && item.IsVideo
        )
        this.detailsImages = this.product.OutRotationPlotDtos.filter(
          (item) =>
            item.Type == this.Enum_RotationPlotShowType.Details && !item.IsVideo
        )
      }
      // 设置专区商品图片
      // if (detailType === 'specialOffer') {
      // }

      // 领券 and 返券
      this.coupons = this._analysisGoodsCoupons(
        this.product.CommodityCouponPackages
      )
      // console.log('领取/返券券包解析详情', this.coupons)
      // if (this.coupons && this.coupons.ReceiveCoupons.length) {
      this.ReceivePanelCoupons = []
      const res1 = await this.getAction('/api_coupon/Coupon/GetCoupons', {
        goodsId: this.product.Id
      })

      if (res1.IsSuccess && res1.Data) {
        const couponsArr = []
        res1.Data.map((item) => {
          const lrt = parseFloat(
            item.OutCouponDto.OutCouponIssueDto.DeductionLimit * 10
          )
            .toFixed(2)
            .toString()
          const l = {
            ...item,
            IsReceive: item.OutCouponDto.IsReceive,
            IsUse: item.OutCouponDto.IsUse,
            Goods: item.OutCouponDto.OutCouponIssueDto.OutCouponLimitGoodsDtos,
            UseRequire:
              item.OutCouponDto.OutCouponIssueDto.OutCouponUseRequireDto,
            DeductionMode: item.OutCouponDto.OutCouponIssueDto.DeductionMode, // 指定金额1，指定比例2，全额抵扣3
            DeductionLimit: item.OutCouponDto.OutCouponIssueDto.DeductionLimit,

            LimitF:
              item.OutCouponDto.OutCouponIssueDto.DeductionMode == 2
                ? lrt.indexOf('.') == -1
                  ? lrt
                  : lrt.substring(0, lrt.indexOf('.'))
                : null,

            LimitL:
              item.OutCouponDto.OutCouponIssueDto.DeductionMode == 2
                ? lrt.indexOf('.') == -1
                  ? null
                  : lrt.substring(lrt.indexOf('.'), lrt.length).replace(/0/, '')
                : null,
            loading: false
          }
          couponsArr.push(l)
        })
        this.ReceivePanelCoupons = couponsArr
        console.log(this.ReceivePanelCoupons, 'ssdd')
      }
      // }

      // 商品基础属性
      this.baseAttribute = []
      this.extendAttribute = []
      if (
        this.product.OutAttributeDtos &&
        this.product.OutAttributeDtos.length > 0
      ) {
        this.Config_Base.forEach((base) => {
          if (base === '包装规格') {
            this.baseAttribute.push({
              AttributeId: 'asdaszs',
              AttributeValue: res.Data.Specifications + '/' + res.Data.Unit,
              AttributeName: '包装规格'
            })
          }
          if (base == '经营范围') {
            this.baseAttribute.push({
              AttributeId: 'asdaszs',
              AttributeValue: res.Data.BusinessScope,
              AttributeName: '经营范围'
            })
          }
          this.product.OutAttributeDtos.forEach((attr) => {
            if (attr.AttributeName == '医保类型' && base == attr.AttributeName && res.Data.MedicalTag && res.Data.MedicalTag.Abbreviation) {
              this.baseAttribute.push({
                AttributeId: 'asdass',
                AttributeValue: this.medicineTypeNoList[Number(res.Data.MedicalTag.Value)],
                AttributeName: '医保类型'
              })
            } else if (attr.AttributeName == '医保代码' && base == attr.AttributeName) {
              this.baseAttribute.push({
                ...attr,
                AttributeValue: (!attr.AttributeValue || attr.AttributeValue == '/') ? '' : attr.AttributeValue
              })
            } else if (base == attr.AttributeName) {
              this.baseAttribute.push(attr)
            }
          })
        })
        if (res.Data.CountryCode) {
          this.baseAttribute.push({
            AttributeId: 'asdas',
            AttributeValue: res.Data.CountryCode,
            AttributeName: '国家码'
          })
        }

        this.goodsTagList = tempList
        // 商品扩展属性
        this.Config_Extend.forEach((extend) => {
          this.product.OutAttributeDtos.forEach((attr) => {
            if (extend == attr.AttributeName) {
              this.extendAttribute.push(attr)
            }
          })
        })

        this.product.OutAttributeDtos.forEach((attr) => {
          const obj = this.extendAttribute.filter(
            (a) => a.AttributeName == attr.AttributeName
          )[0]
          if (
            !obj &&
            !this.Config_Base.includes(attr.AttributeName) &&
            !this.Config_Extend.includes(attr.AttributeName)
          ) {
            this.extendAttribute.push(attr)
          }
        })

        //   console.log(this.baseAttribute, this.extendAttribute, this.product.OutAttributeDtos)
      }

      // 商品活动
      this.salesPromotions = this._analysisGoodsActivity(
        this.product.SalesPromotions
      )

      // console.log('解析商品活动', this.salesPromotions)

      // 新品
      if (
        this.product.NewProductTime &&
        moment().isBefore(moment(this.product.NewProductTime))
      ) {
        this.timer.new = setInterval(() => {
          const array = this._analysisActivityDiffTime(
            this.product.NewProductTime,
            moment()
          )
          const time = this._setTimerArr(array[1])
          let flag = true
          time.push(Number(array[0]))
          time.forEach((t) => {
            if (Number(t) < 0) {
              clearInterval(this.timer.new)
              flag = false
            }
          })
          if (flag) {
            this.timer.newTime = time
          }
          // console.log(time)
        }, 1000)
      }
      // 即将到货
      if (
        this.product.EstimatedTime &&
        moment().isBefore(moment(this.product.EstimatedTime))
      ) {
        this.timer.soon = setInterval(() => {
          const array = this._analysisActivityDiffTime(
            this.product.EstimatedTime,
            moment()
          )
          const time = this._setTimerArr(array[1])
          let flag = true
          time.push(Number(array[0]))
          time.forEach((t) => {
            if (Number(t) < 0) {
              clearInterval(this.timer.soon)
              flag = false
            }
          })
          if (flag) {
            this.timer.soonTime = time
          }
          // console.log(time)
        }, 1000)
      }
    }, // end- get goods detail

    async getRandomGoods() {
      const res = await this.getAction(`${this.url.getRandomGoods}`)
      // console.log('随机获取商品列表', res)
      if (res.IsSuccess) {
        this.relevantList = res.Data
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 复制
    onCopy: function(e) {
      console.log(e)
      this.$toast.success('复制成功！')
    },
    onError: function(e) {
      this.$toast.fail('复制失败！')
    },
    // 显示领券
    handleShowCoupon() {
      this.$refs.coupon.bool = true
    },
    // 显示更多活动
    showMoreActivity() {
      if (this.coupons && this.coupons.ReceiveCoupons.length) {
        this.showCouponPanel = true
      }
    },

    // 订阅收藏 -------------------------------------------------------------------
    // 操作订阅收藏
    async operateCollect(collectType) {
      const key =
        collectType == this.Enum_CollectType.Goods ? 'Goods' : 'Subscribe'
      const isCollect = this.collects[key].IsCollect
      const collectId = this.collects[key].Id
      if (isCollect) {
        this.cancelCollect(collectType, key, collectId)
      } else {
        this.setCollect(collectType, key)
      }
    },

    // 订阅&收藏
    async setCollect(collectType, key) {
      const title =
        collectType == this.Enum_CollectType.Goods ? '收藏成功' : '订阅成功'
      const data = {
        CollectType: collectType,
        CollectingBusinessId: this.product.Id,
        CollectionPrice: this._getProductPrice(
          this.product.PriceActivity,
          this.product.PriceLimit
        )
      }
      this.$hys.openLoading()
      const res = await this.postAction(`${this.url.createLike}`, data)
      this.$hys.clearLoading()
      console.log('收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = res.Data
        this.collects[key].IsCollect = true
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 取消订阅&收藏
    async cancelCollect(collectType, key, collectId) {
      const title =
        collectType == this.Enum_CollectType.Goods
          ? '取消收藏成功'
          : '取消订阅成功'
      this.$hys.openLoading()
      const res = await this.deleteAction(
        `${this.url.deleteLike}?ids=${collectId}`
      )
      this.$hys.clearLoading()
      console.log('取消收藏订阅', res)
      if (res.IsSuccess) {
        this.collects[key].Id = ''
        this.collects[key].IsCollect = false
        this.$toast(title)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 获取收藏订阅
    async getCollect(goodsId) {
      const res = await this.getAction(
        `${this.url.getCollect}?collectingBusinessId=${goodsId}`
      )
      console.log('获取收藏订阅详情', res)
      if (res.IsSuccess) {
        const data = res.Data
        const goodsCollects = data.filter(
          (item) => item.CollectType == this.Enum_CollectType.Goods
        )
        const subscribeCollects = data.filter(
          (item) => item.CollectType == this.Enum_CollectType.Subscribe
        )
        if (goodsCollects.length > 0) {
          this.collects['Goods'].Id = goodsCollects[0].Id
          this.collects['Goods'].IsCollect = true
        }
        if (subscribeCollects.length > 0) {
          this.collects['Subscribe'].Id = subscribeCollects[0].Id
          this.collects['Subscribe'].IsCollect = true
        }
      } else {
        //   this.$toast(res.Msg)
      }
    },
    // ------------------------------------------------------------------- 订阅收藏/

    // 查看视频
    showVideo(vid, cover) {
      vid = 'bfa3a366c3aa408ebbe1ead32acf76e1'
      const res = this.getAction(`${this.url.getPlayAuth}?vid=${vid}`)
      console.log('获取视频播放凭证', res)
      if (!res.IsSuccess) {
        return
      }
      const height = '340'
      const playauth = res.Data.PlayAuthToken
      const callback = ''
      setTimeout(() => {
        this._createAliPlay(
          'J_prismPlayer',
          vid,
          cover,
          height,
          playauth,
          callback
        )
      }, 300)
    },

    // 确认购物车
    async confirmCart() {
      const { IsAccord } = this.product
      if (!IsAccord && !this.isOldBuy && IsAccord != null) {
        // 判断是否有资格购买
        this.joinModal = true
      } else {
        if (this.product.cartNum > this.product.Stock) {
          this.$toast({
            position: 'bottom',
            message:
              '购买商品数量超过了该商品库存，库存余（' +
              this.product.Stock +
              '）'
          })
          this.product.cartNum = this.product.Stock
          return
        }
        if (
          !!this.product.LimitPerOrder &&
          this.product.cartNum > this.product.LimitPerOrder
        ) {
          this.$toast({
            position: 'bottom',
            message:
              '单笔订单限购（' +
              this.product.LimitPerOrder +
              '）' +
              this.product.Unit
          })
          const rightNum = this.$hys.checkLimitPerOrder(
            this.product.OutPurchaseAgreementDto.PurchaseNumber,
            this.product.OutPurchaseAgreementDto.StepLengthNumber,
            this.product.LimitPerOrder
          )
          if (rightNum > this.product.OutPurchaseAgreementDto.PurchaseNumber) {
            this.product.cartNum = rightNum
          } else {
            this.product.cartNum = this.product.OutPurchaseAgreementDto.PurchaseNumber
          }
          return
        }
        this.product.cartNum = this.product.cartNum ? this.product.cartNum : 0
        // this.product.cartNum = this.cartCount;
        const formData = {
          ProductSKUId: this.product.Id,
          Count: this.product.cartNum,
          IsAdd: true,
          IsPrice: this.isOldBuy
        }

        if (this.ActivityId && this.ActivityId != '00000000-0000-0000-0000-000000000000') formData.ActivityId = this.ActivityId

        const res = await this.postAction(this.url.addOrUpdateCart, formData)
        if (res.IsSuccess && res.Data) {
          this.$nextTick(() => {
            if (res.Data.CountData) {
              // 判断是否可以加购
              if (res.Data.IsLimitPerOrder && !!this.addCartSetting.SigleOrderLimitNumb) {
                const rightNum = this.$hys.checkLimitPerOrder(
                  this.addCartSetting.StartBuyNumb,
                  this.addCartSetting.StepSize,
                  this.addCartSetting.SigleOrderLimitNumb
                )
                if (
                  rightNum > this.addCartSetting.StartBuyNumb
                ) {
                  // this.product.cartNum = rightNum
                } else {
                  // this.product.cartNum = this.addCartSetting.StartBuyNumb
                }
                this.$toast({
                  position: 'bottom',
                  message:
                    '单笔订单限购（' +
                    this.addCartSetting.SigleOrderLimitNumb +
                    '）盒'
                })
                return false
              }
              // this.$refs['iNav'].carCount = res.Data.CountData.ProductCount
              this.$bus.$emit(
                'buycarChanged',
                res.Data.CountData.ProductCount,
                true
              )
              this.$bus.$emit(
                'rightBuycarChanged',
                res.Data.CountData.ProductCount,
                true
              )
            }
            this.$toast({
              position: 'center',
              message: '添加购物车成功'
            })
          })
        } else {
          this.$toast({ position: 'bottom', message: res.Msg })
        }
      }
    },

    // 商品是否是特价商品
    getProductLabType(item) {
      let list = []
      if (item.OutLabelDtos && item.OutLabelDtos.length) {
        list = item.OutLabelDtos.filter(
          (tag) => tag.Name.indexOf('特价') != -1
        )
      }
      return list
    },
    // 跳转详情
    showRouter: function(item) {
      // this.getProduct(item.Id)
      this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, '_blank')
    },
    handleDraw() {
      this.$refs.iDialogref.iShow()
      this.getProduct()
      // this.getRandomGoods();
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./Style/ProductDetails.less");

.tag-list {
  margin: 12px 0;
  height: 20px;

  >div {
    display: inline-block;
    border-radius: 2px;
  }

  .tag-box {
    margin-right: 2px;
    border: 1px solid #019491;
    border-radius: 2px;
    padding: 0 4px;
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #019491;
    line-height: 16px;
  }

  .tag-type-1 {
    border: 1px solid #FE3F3F;
    color: #FE3F3F;
  }

  .tag-type-2 {
    border: 1px solid #019491;
    color: #019491;
  }

  .tag-type-3 {
    border: 1px solid #06B266;
    color: #06B266;
  }

  .tag-release {
    border-radius: 2px;
    padding: 4px 0 4px 8px;
    width: 140px;
    height: 20px;
    font-size: 12px;
    color: #111A34;
    background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #F0F3F5 100%);
  }

  .red-release {
    background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #FFF1F0 100%);
  }
}
// 右上方图片
.icon-lt {
  position: absolute;
  top: 12px;
  left: 12px;

  img {
    width: 100px;
    height: 76px;
  }
}

.type-icon {
  img {
    background-color: unset;
  }
}

.icon-tj {
  position: absolute;
  bottom: 0;
  left: 4px;
  border: 1px solid #FF3939;
  border-radius: 12px;
  width: 54px;
  height: 20px;
  font-size: 12px;
  text-align: center;
  color: #FF3939;
  background: rgba(255, 206, 206, .65);
}
//下方icon
.icon-bt {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 0 0 4px 4px;
  height: 22px;
  font-size: 12px;
  color: #FFFFFF;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  span {
    display: inline-block;
    overflow: hidden;
    margin: 2px 5px auto 46px;
    width: 90px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.specifications {
  padding-top: 4px;
  font-size: 16px;
  color: #111A34;
}
// .colect_btn{
// 	&:active {
// 		&::before {
// 			display: block;
// 			content: '';
// 			position: absolute;
// 			top: 0px;
// 			left: 0px;
// 			width: 100%;
// 			height: 100%;
// 			background-color: #0250c4;
// 		}
// 	}
// }
.ready-btn {
  position: relative;
  border-radius: 2px;
  width: 154px;
  height: 50px;
  font-size: 16px;
  text-align: center;
  color: #FFFFFF;
  background: #0F6EE9;
  line-height: 50px;
  cursor: pointer;
}

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
}

.close-box {
  margin-top: 20px;
  color: #FFFFFF;
}

.icon-close {
  cursor: pointer;
  font-size: 30px;
}

.ncond-bg {
  padding: 24px 32px;
  width: 372px;
  background: url("../../assets/activity-m.png");
  background-size: 100% 100%;
  box-sizing: border-box;
}

.cond-bg {
  padding: 16px;
  width: 544px;
  background: url("../../assets/activity-m.png");
  background-size: 100% 100%;
  box-sizing: border-box;
}

.modal-content {
  .title {
    font-size: 26px;
    text-align: center;
    color: #FFFFFF;
  }

  .disc {
    margin-top: 8px;
    text-align: center;
    color: #FFFFFF;
  }

  .content {
    margin-top: 20px;
    border-radius: 12px;
    padding: 16px;
    background: #FFFFFF;
    box-shadow: 0 0 8px 0 #7FABFF;

    .list {
      margin-bottom: 8px;
      text-align: left;
      color: #111A34;
    }
  }

  .btn {
    margin-top: 12px;
    border: 0;
    border-radius: 22px;
    width: 261px;
    height: 40px;
    color: #111A34;
    background: linear-gradient(180deg, #FFEC32 0%, #FFD417 100%);
    cursor: pointer;
  }

  .btn-s2 {
    background: #FFFFFF;
  }
}

.ll-bg1 {
  background: linear-gradient(270deg, #FFFFFF 0%, #F4E2E4 100%) !important;
}

.ll-bg2 {
  background: linear-gradient(270deg, #FFEEEC 0%, #FFDBD9  100%) !important;
}

.zhy {
  margin-right: 4px;
  padding: 0 6px 0 18px;
  height: 22px;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  background: url("../../assets/buycardetail/zkbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .info {
    width: 12px;
    height: 12px;
  }
}

.icon-lt-5 {
  img {
    width: 80px;
    height: 62px;
  }
}
</style>
